module.exports = __webpack_public_path__ + "static/img/tip-5.34e4d73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-5.png
// module id = JxW2
// module chunks = 1